import React from 'react';

import styled from 'styled-components';

import CloseIcon from '@mui/icons-material/Close';

const StyledPopoverCloseButton = styled.button`
  position: absolute;
  top: -1.125rem;
  right: -1.125rem;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  min-width: 2.25rem;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  border: 2px solid ${props => props.theme.custom.palette.primaryOrange};
  color: ${props => props.theme.custom.palette.primaryOrange};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  padding: 0;
  cursor: pointer;

  svg {
    font-size: 1.25rem;
  }

  &:hover {
    background-color: ${props => props.theme.custom.palette.primaryOrange};
    color: white;
    transform: scale(1.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

type ModalCloseButtonProps = {
  className?: string;
  onClose: () => void;
  isDisabled?: boolean;
};

export const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  className,
  onClose,
  isDisabled,
}) => {
  return (
    <StyledPopoverCloseButton
      className={className}
      onClick={onClose}
      disabled={isDisabled}
      type="button"
    >
      <CloseIcon />
    </StyledPopoverCloseButton>
  );
};
